
export default {
  orsLPolyline: {
    'type': 'Típus',
    'surface': 'Felszín',
    'unknownSurfaceType': 'Ismeretlen'
  }
}
